//drawer container var
var $drawerWrapper = $("#drawer-wrapper");

/** DRAWER **/
$(".drawer-close", $drawerWrapper).click(function (e) {
e.preventDefault();
theme.Drawer.closeDrawer();
});

$("#CartButton").click(function (e) {
  e.preventDefault();
  theme.Drawer.openDrawer();
  e.stopPropagation();
});

var cartItemChangeQty = function (data, success, fail=null, finallyCb=null) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,

    success: function (res, textStatus, jqXHR) {
      if (typeof success === "function") {
        success(res, textStatus, jqXHR);
      }
    },

    error: function (jqXHR, textStatus, errorThrown) {
      if (typeof fail === "function") {
        fail(jqXHR, textStatus, errorThrown);
      }
    },

    complete: function (jqXHR, textStatus) {
      if (typeof finallyCb === "function") {
        finallyCb(jqXHR, textStatus);
      }
    }
  });
};

var removeCartItem = function (cartItem) {
  cartItem.animate(
      {
      opacity: 0,
      },
      300,
      function () {
      cartItem.remove();
      }
  );

  theme.Drawer.cartChange(false);
};

$(document).on("click", ".cart-item-remove-container", function () {
var qty = 0;
var cartItem = $(this).parents(".cart-item");
var key = cartItem.data("id");
var data = { quantity: qty, id: key };

cartItemChangeQty(data, removeCartItem(cartItem));
});

$(document).on("click", ".drawer-qty-adjust", function (e) {
  e.preventDefault();
  var el = $(this),
      qtySelector = el.siblings(".js-qty__num.quantity__input"),
      qty = parseInt(qtySelector.val().replace(/\D/g, ""));

  var cartItem = el.parents(".cart-item");

  //remember old value for backtracking in case update fails
  qtySelector.data('oldValue', qty);

  // Make sure we have a valid integer
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a number!
  } else {
      // Not a number. Default to 1.
      qty = 1;
  }

  if (el.hasClass("quantity__minus")) {
      qty = qty - 1;
  } else {
      qty = qty + 1;
  }

  qtySelector.val(qty);
  qtySelector.trigger("change");
});

$(document).on("change", ".js-qty__num.quantity__input", function () {
  console.log("qty_change");

  const cl = {
    error: 'has-error'
  }

  var qty = $(this).val();
  var $qtyAdjust = $(this).siblings('.js-drawer-qty-adjust');
  var $this = $(this);
  //combine two controls
  var $qtyControls = $qtyAdjust.add($this);
  var $cartItem = $(this).parents(".cart-item");
  var key = $cartItem.data("id");
  var data = { quantity: qty, id: key };

  //disable qty
  $qtyControls.prop('disabled', true);

  //reset cart item
  $cartItem.removeClass(cl.error)

  if (qty == 0) {
      removeCartItem($cartItem);
  }

  const fail = (jqXHR, textStatus, errorThrown) => {
    //revert to old value if fail
    var oldValue = $this.data('oldValue');
    $this.val(oldValue);

    console.log('error: ', jqXHR, textStatus, errorThrown);

    const errorMessage = jqXHR.responseJSON?.message || "";

    $cartItem.find('.js-cart-item-error-text').text(errorMessage);

    $cartItem.addClass(cl.error)
  }

  const finallyCb = () => {
    $qtyControls.prop('disabled', false);
  }

  const success = () => {
    theme.Drawer.cartChange(false);
  }

  cartItemChangeQty(data, success, fail, finallyCb);
});


//drawer init

window.addEventListener("load", function () {
  theme.Drawer.cartReloadPageRefresh();
  console.log("drawer loaded");
});

window.addEventListener("pageshow", function (event) {
  var historyPage =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyPage) {
    theme.Drawer.cartReloadPageRefresh();
    console.log("back drawer loaded");
  }
});


/** DRAWER SCRIPT **/
theme.Drawer = {
  addToCartOkay: function (product) {
    var $drawerWrapper = $(".drawer-wrapper");

    console.log(product);

    var itemFound = theme.Drawer.checkDrawerItems(product);
    if (itemFound != false) {
      var qty = product.quantity;
      var $cartItem = $drawerWrapper.find('[data-id="' + itemFound + '"]');
      var $qtyContainer = $cartItem.find(".quantity__input");
      console.log($cartItem);
      $qtyContainer.val(qty);
    } else {
      theme.Drawer.addItemToDrawer(product);
    }

    theme.Drawer.cartChange(false, product);

    theme.Drawer.openDrawer();

    /* GOOGLE ADS ADD TO CART CONVERSION REPORT

    //divide by 100 for correct value format
    let conversionValue = product.final_price / 100
    googleAdsReportATC(conversionValue)
    /* END GOOGLE ADS ADD TO CART CONVERSION REPORT */ 
  },

  checkDrawerItems: function (product) {
    var $drawerWrapper = $(".drawer-wrapper");
    var $drawerCartItems = $drawerWrapper.find(".cart-item");
    var itemFound = false;
    $drawerCartItems.each(function () {
      var id = $(this).data("id");
      var searchKey = product.key;
      console.log(searchKey);
      if (id == searchKey) {
        itemFound = id;
      }
    });

    return itemFound;
  },

  addItemToDrawer: function (product) {
    var isSale = false;
    var $drawerWrapper = $(".drawer-wrapper");
    var $cartItemWrapper = $drawerWrapper.find(".cart-item-wrapper");

    var price = product.discounted_price;

    var title = product.product_title;
    var url = product.url;
    // remove url query string
    url = url.split("?");
    url = url[0];
    var image = product.image;
    image = slate.Image.getSizedImageUrl(image, "220x220");
    var quantity = product.quantity;

    var sellingPlanName = "";
    if (
      product.selling_plan_allocation &&
      product.selling_plan_allocation.selling_plan &&
      product.selling_plan_allocation.selling_plan.name
    ) {
      sellingPlanName = product.selling_plan_allocation.selling_plan.name;
    }
    var compare_price = 0;
    if (product["properties"] !== null && product["properties"] !== undefined) {
      if (
        product["properties"]["_compareprice"] !== null &&
        product["properties"]["_compareprice"] !== undefined
      ) {
        compare_price = product["properties"]["_compareprice"];
      }
    }

    if (compare_price > price) {
      isSale = true;
    }

    price = slate.Currency.formatMoney(price, theme.moneyFormat);
    compare_price = slate.Currency.formatMoney(
      compare_price,
      theme.moneyFormat
    );
    var key = product.key;
    var variant = "";

    if (product.variant_title !== null) {
      variant = product.variant_title;
    }

    var cart_item =
      `<div class="cart-item" data-id="` +
      key +
      `">
          <div class="cart-item-image">
            <img src="` +
      image +
      `">
          </div>
          <div class="cart-item-content">
            <h6 class="cart-item-title">
              <a href="` +
      url +
      `">
                 ` +
      title +
      `
              </a>
            </h6>
			<div class="cart-item-variant">
				` +
      variant +
      `
		   </div>
		   <div class="cart-item-selling-plan-name">
				` +
      sellingPlanName +
      `
		   </div>

            
            <div class="drawer-control-group">
              <div class="quantity-selector drawer-quantity-selector">
                <button data-operation="minus" class="drawer-qty-adjust js-drawer-qty-adjust quantity__minus">
					<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>
				</button>
				<input data-old-value="${quantity}" type="text" class="js-qty__num quantity__input" value="` +
      quantity +
      `" min="1" aria-label="quantity" pattern="[0-9]*" name="quantity">
                <button data-opeation="plus" class="drawer-qty-adjust js-drawer-qty-adjust quantity__plus">
					<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>
				</button>
              </div>


			  <p><span class="cart-item-price money">` +
      price +
      `</span>
				 <s class="cart_item product__price--strike hide" >` +
      compare_price +
      `</s>
		     </p>
            </div>
			
            <a class="cart-item-remove-container">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 20 20"><path fill="#444" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"/></svg>
            </a>
            <p class="js-cart-item-error-text cart-item-error-text"> </p>
          </div>
          
        </div>`;

    var $cart_item = $(cart_item);
    if (isSale) {
      $cart_item.find(".product__price--strike").removeClass("hide");
      $cart_item.find(".cart-item-price").addClass("product__price--sale");
    }

    $cartItemWrapper.prepend($cart_item);
  },

  cartChange: function (cart, product = false) {
    if (cart == false) {
      $.ajax({
        dataType: "json",
        url: "/cart.js",
        cache: false,
        success: function (newCart) {
          theme.Drawer.updateTotal(newCart);
          theme.Drawer.buildRecommendation(newCart);
          if (product != false) {
            theme.Drawer.buildProductRecommendation(product, newCart);
          }

          //theme.Drawer.cartCheck(newCart);
          theme.Drawer.changeCartCount(newCart.item_count);
        },
      });
    } else {
      //console.log(cart);
      theme.Drawer.updateTotal(cart);
      theme.Drawer.buildRecommendation(cart);
      if (product != false) {
        theme.Drawer.buildProductRecommendation(product, cart);
      }

      //theme.Drawer.cartCheck(cart);
      theme.Drawer.changeCartCount(cart.item_count);
    }
  },

  changeCartCount: function (cart_items) {
    cart_items = parseInt(cart_items);
    if (cart_items > 0) {
      $("#CartButton .cart-count-js").text(cart_items);
      $("#CartButton .header__cart__count").show().addClass("pulse-cart-icon");
      setTimeout(function () {
        $("#CartButton .header__cart__count").removeClass("pulse-cart-icon");
      }, 800);
    } else {
      $("#CartButton .header__cart__count").hide();
    }
  },

  cartReloadPageRefresh: function () {
    $("#CartButton .header__cart__count").hide();
    $.ajax({
      dataType: "json",
      url: "/cart.js",
      cache: false,
      success: function (newCart) {
        //clear cart wrapper before appending items
        console.log("reload", newCart);

        $(".cart-item-wrapper").empty();
        for (var i = 0; i < newCart.items.length; i++) {
          //console.log(newCart.items[i]);
          theme.Drawer.addItemToDrawer(newCart.items[i]);
        }
        theme.Drawer.updateTotal(newCart);
        theme.Drawer.buildRecommendation(newCart);

        //theme.Drawer.cartCheck(newCart);
        theme.Drawer.changeCartCount(newCart.item_count);
      },
    });
  },

  cartCheck: function (cart) {
    //NO NEED TO HIDE DYNAMIC PAYMENT BUTTONS - SHOPIFY SUBSCRIPTION CHECKOUT
    /*
    var isSubscription = false;
    for (var i = 0; i < cart.items.length; i++) {
      if (theme.Drawer.checkSubscriptionProduct(cart.items[i])) {
        isSubscription = true;
      }
    }

    if (isSubscription) {
      $(".drawer-buttons .additional").hide();
    } else {
      $(".drawer-buttons .additional").show();
    }
    */
  },

  updateTotal: function (cart) {
    var automatic_discount_title = false;
    var subtotal = cart.total_price;
    var remove_discounts = 0;

    $(".cart-count-js").html(cart.item_count);
    $("#drawer-subtotal-price").html(
      slate.Currency.formatMoney(subtotal, theme.moneyFormat)
    );
  },

  showDrawer: function () {
    $("#CartButton").trigger("click");

  },

  isFreeShipping: function (cart) {
    let total_price = cart.total_price;
    for (var i = 0; i < cart.items.length; i++) {
      //NEW SUBSCRIPTION CHECKER - SHOPIFY CHECKOUT INTEGRATION
      let item = cart.items[i];

      //check if item is subscription
      if (
        !item.selling_plan_allocation ||
        !item.selling_plan_allocation.selling_plan
      )
        continue;

      total_price -= item.final_line_price;
    }

    var freeShippingTreshold = theme.cart.freeShippingThreshold;
    let missing_amount = freeShippingTreshold - total_price;

    if (missing_amount > 0) return missing_amount;

    return true;
  },

  buildRecommendation: function (cart) {
    var footerPromoTextContainer = $(".promo-text-js");
    var freeShippingTreshold = parseFloat(
      footerPromoTextContainer.data("freeshipping-threshold")
    );

    var isFreeShipping = theme.Drawer.isFreeShipping(cart);

    if (cart.items.length == 0) {
      var freeShippingText = `<p>${theme.strings.empty_cart_text}&nbsp;<a href="${window.Shopify.routes.root}collections"><span class="drawer-footer-emp">${theme.strings.continue_shopping}</span></a></p>`;
      footerPromoTextContainer.html($(freeShippingText));
    } else if (isFreeShipping !== true) {
      var missingAmount = isFreeShipping;
      var missingAmountFormat = slate.Currency.formatMoney(
        missingAmount,
        theme.moneyFormat
      );
      var freeShippingText = "<p>" + theme.strings.cart_shipping_text + "</p>";
      freeShippingText = freeShippingText.replace(
        "{{ freeShippingDiff }}",
        missingAmountFormat
      );
      footerPromoTextContainer.html($(freeShippingText));
    } else {
      var freeShippingText = "<p>" + theme.strings.free_shipping_text + "</p>";
      footerPromoTextContainer.html($(freeShippingText));
    }
  },

  getProductForRecommendation: function (handle, cart, heading, callback) {
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (result) {
        console.log('recommendation: ', result);
        var product = {
          title: result.title,
          url: result.url,
          price: result.price,
          id: result.variants[0].id,
          image: result.featured_image,
          available: result.available
        };
        
        if(product.available){
          theme.Drawer.addProductRecommendation(product, cart, heading);
        }

        if (typeof callback === "function") callback();
      }
    );
  },

  buildProductRecommendation: function (product, cart) {
    var $suggestedContainer = $(".suggested-product-container");
    var $suggestedWrapper = $(".drawer-footer-suggested-products");
    var suggestedHeadingText = "";

    var isFreeShipping = theme.Drawer.isFreeShipping(cart);
    var handle = product.handle;

    $suggestedContainer.empty();

    jQuery.getJSON("/products/" + handle, function (newProduct) {
      //console.log('with tags', newProduct);
      var tags = newProduct.product.tags.split(",");
      var suggested_handles = [];
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].includes("suggested")) {
          var suggested_item = tags[i].split(":");
          suggested_handles.push(suggested_item[1]);
        }
      }

      var pairs_with_heading = theme.strings.cart_pairs_with.heading;

      //console.log(suggested_handles);

      if (isFreeShipping !== true) {
        /*
          suggestedHeadingText = "Add more to your cart:";
          theme.Drawer.addProductRecommendation(product,cart, suggestedHeadingText);
          */

        if (suggested_handles.length > 0) {
          theme.Drawer.getProductForRecommendation(
            suggested_handles[0],
            cart,
            pairs_with_heading,
            function () {
              if (suggested_handles.length > 1) {
                theme.Drawer.getProductForRecommendation(
                  suggested_handles[1],
                  cart,
                  false,
                  false
                );
              }
            }
          );
        }
      } else {
        if (suggested_handles.length > 0) {
          theme.Drawer.getProductForRecommendation(
            suggested_handles[0],
            cart,
            pairs_with_heading,
            function () {
              if (suggested_handles.length > 1) {
                theme.Drawer.getProductForRecommendation(
                  suggested_handles[1],
                  cart,
                  false,
                  false
                );
              }
            }
          );
        }
      }
    });
  },

  addProductRecommendation: function (product, cart, heading) {
    //console.log('add product recommendation');

    var $suggestedContainer = $(".suggested-product-container");
    var $suggestedWrapper = $(".drawer-footer-suggested-products");

    var title = product.title;
    var url = product.url;
    var price = slate.Currency.formatMoney(product.price, theme.moneyFormat);
    var img = slate.Image.getSizedImageUrl(product.image, "80x80");
    var id = product.id;
    var add_label = theme.strings.cart_pairs_with.add;


    var suggestedProductTemplate =
      `<div class="suggested-product">
                <div class="suggested-product-content">
                  <img src="` +
      img +
      `">
                  <div class="suggested-product-text">
					<a href="` +
      url +
      `">
                    <p class="suggested-product-title">` +
      title +
      `</p>
					</a>
                    <p class="suggested-product-price">` +
      price +
      `</p>
                  </div>
                </div>
				<a data-id="` +
      id +
      `" class="product-grid-add-js">
                <button class="suggested-product-cta" >
                  ` +
      add_label +
      `
                </button>
				</a>
              </div>`;


    $suggestedContainer.append(suggestedProductTemplate);
    $suggestedWrapper.show();
  },

  closeDrawer: function (params) {
    var $drawerWrapper = $(".drawer-wrapper");


    $drawerWrapper.addClass('closing');

    setTimeout(function(){
      $("body , html").removeClass("drawer-open");
      
      $drawerWrapper.addClass("close");

      $drawerWrapper.removeClass("open");

      $drawerWrapper.removeClass("closing");

      window.removeEventListener('click', theme.Drawer.handleClickOutside)

    }, 800)

    const drawerMain = document.querySelector('.drawer-main');
    bodyScrollLock.enableBodyScroll(drawerMain);
  },

  openDrawer: function () {
    var $drawerWrapper = $(".drawer-wrapper");

    if (!$drawerWrapper.hasClass("open")) {

       

      console.log('open'); 
      theme.ChatWidget.hide();

      $drawerWrapper.removeClass("close");
      $("body , html").addClass("drawer-open");

      $drawerWrapper.addClass("open");

      window.addEventListener('click', theme.Drawer.handleClickOutside)

      //init body scroll loock
      const drawerMain = document.querySelector('.drawer-main');
      bodyScrollLock.disableBodyScroll(drawerMain);

    }
  },

  handleClickOutside: function (e) {
    if (
      !$(e.target).is(".drawer-main *") &&
      $("html").hasClass("drawer-open")
    ) {

      console.log('ehy');
      theme.Drawer.closeDrawer();
    }
  }
};
